// extracted by mini-css-extract-plugin
export default {"callButton":"CallButton_callButton__rgIGh","buttonText":"CallButton_buttonText__CoYtr"};